import http from '@/http-common'
import InputGroupForm from '@/components/InputGroupForm.vue'
import ModalEkp from '@/views/ekpForm/ModalFormEkp'
import global from "@/utils/global";
import Store from '@/store'
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";

export default {
  name: "ModalFilterEkp",
  components: {FormSelectVue, InputGroupForm, ModalEkp},
  props: {
    value: {
      dat1: null,
      dat2: null
    },
    orgList: [],
    ekpTypeList: [],
    eventKinds: [],
    eventStateList: [],
    fedList: [],
    sportKindList: [],
    locationList: [],
    jobKindList: [],
    changeList: [],
    ageKindList: [],
    heldList: []
  },
  data() {
    return {
      widthFilterModal: '70%',
      sumTypes: [],
      docTypes: [],
      docList: [],
      filterEkp: {
        dat1: null,
        dat2: null,
        changeValue: null,
        sportKindId: null,
        federationId: null,
        locationId: null,
        jobKindId: null,
        docId: null,
        sumTypeId: 0
      },
      showFilter: false
    }
  },
  created() {
    for (let key in this.value) {
      this.filterEkp[key] = this.value[key];
    }
    this.loadTypesDoc()
    this.loadSumTypes()
    this.onResize();
  },
  methods: {
    onResize() {
      if (document.documentElement.clientWidth > global.isMobileWidth()) {
        this.widthFilterModal = '70%'
      } else {
        this.widthFilterModal = '90%'
      }
    },
    loadItems() {
      this.$emit("loadItems");
    },
    cleanFilter() {
      const dat = new Date();
      let filterData = {}
      filterData.dat1 = (dat.getFullYear()).toString() + "-01-01";
      filterData.dat2 = (dat.getFullYear()).toString() + "-12-31";
      filterData.federationId = null;
      filterData.eventKindId = null;
      filterData.eventStateId = null;
      filterData.heldValue = null;
      filterData.changeValue = null;
      filterData.sportKindId = null;
      filterData.locationId = null;
      filterData.sumTypeId = 0;
      filterData.ekpTypeId = null;
      filterData.jobKindId = null;
      filterData.organizationId = 1;
      // this.loadItems();
      // this.showFilter = false
      Store.dispatch('putFilter', filterData)
      this.$emit("input", filterData)
      this.$emit("loadItems");
    },
    loadSumTypes() {
      let vm = this;
      vm.sumTypes = []
      http.get('/option/sumType')
      .then((response) => {
        vm.sumTypes = response.data;
      })
      .catch((error) => console.log(error.message))
    },
    loadDocsByType() {
      let vm = this;
      vm.docList = [];
      if (vm.filterEkp.docTypeId) {
        http.get('/document/docs/byType/' + vm.filterEkp.docTypeId)
        .then((response) => {
          vm.docList = response.data;
        })
        .catch((error) => console.log(error.response.data));
      }
    },
    loadTypesDoc() {
      this.docTypes = [];
      http.get('/workkind/DOC_TYPE/option')
      .then((response) => {
        this.docTypes = response.data;
        this.loadDocsByType();
      })
      .catch((error) => console.log(error.response));
    },
    checkDate1() {
      let vm = this;
      if (vm.filterEkp.dat1 > vm.filterEkp.dat2) {
        vm.filterEkp.dat2 = vm.filterEkp.dat1
      }
    },
    checkDate2() {
      let vm = this;
      if (vm.filterEkp.dat1 > vm.filterEkp.dat2) {
        vm.filterEkp.dat1 = vm.filterEkp.dat2
      }
    },
    applyFilter() {
      Store.dispatch('putFilter', this.filterEkp)
      this.$emit("input", this.filterEkp)
      this.$emit("loadItems");
      this.closeModal()
    },
    closeModal() {
      this.showFilter = false
    }
  }
}
